// extracted by mini-css-extract-plugin
export default {"ats":"Lx3vszjnofW0xfybt_IG","rating":"lzo76TQxNrbEAawaLjfD"};